import { useQuery } from '@tanstack/react-query';

import { callGetCollectionFloorPriceBySlug } from '@app/client/resources/collections/collection';

export const useSlugFloorPrice = (slug: string, disabled?: boolean) => {
    const { data: response, ...rest } = useQuery(
        ['slugFloorPrice', slug],
        ({ signal }) =>
            callGetCollectionFloorPriceBySlug({
                slug,
                settings: { signal },
            }),
        {
            retry: true,
            keepPreviousData: true,
            enabled: Boolean(slug) && !disabled,
        },
    );
    let resData;
    if (response?.ok && response.value) {
        resData = response.value;
    }

    return { data: resData, ...rest };
};
